var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.06688 1C6.15896 1 4.85522 2.52521 5.16791 4.38907L5.64489 7.21111C5.83303 8.32943 6.92213 9.24561 8.06688 9.24561C9.21163 9.24561 10.3034 8.33205 10.4889 7.21111L10.9632 4.38907C11.2759 2.52521 9.97214 1 8.06423 1H8.06688Z",
    stroke: "#2E3138 ",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0136 10.5478L10.6959 9.45306C9.999 10.1277 9.06094 10.5583 8.06724 10.5583C7.07353 10.5583 6.13547 10.1277 5.43855 9.45306L2.11825 10.5478C1.50348 10.7499 1 11.4429 1 12.0835V15H15.1318V12.0835C15.1318 11.4429 14.6283 10.7499 14.0136 10.5478Z",
    stroke: "#2E3138 ",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconBlue);
export default __webpack_public_path__ + "static/media/ProfileIconBlue.0f216318e45a78fb00eaa875f09228e7.svg";
export { ForwardRef as ReactComponent };